import * as yup from 'yup';

export const schema = yup.object().shape({
  emails: yup.string().required(),
  sms: yup.string().required(),
  shipments: yup.string().required(),
  id: yup.string().required(),
});
